import { ErrorFallback } from '@/shared/ui/ErrorBoundary';
import { SuspenseFallback } from '@/shared/ui/SuspenseFallback';

import { TagCategoryHeader } from '@/features/tags/ui/TagCategoryHeader';
import { TagCategoryTable } from '@/features/tags/ui/TagCategoryTable';
import { TagDetailHeader } from '@/features/tags/ui/TagDetailHeader';

import { TagAssetList } from '@/widgets/tags/TagAssetTab/ui';
import { TagCategorySidebar } from '@/widgets/tags/TagCategorySidebar';
import { TagDetailSidebar } from '@/widgets/tags/TagDetailSidebar';

import styles from './TagContents.module.css';

type TagContentsProps = {
  selectedTagCategory: string;
  selectedTagName?: string;
  selectedTagFqn?: string;
  onTreeRefresh?: (parentFqn: string) => void;
};

export const Main = ({ selectedTagCategory, selectedTagName, selectedTagFqn, onTreeRefresh }: TagContentsProps) => {
  return (
    <article className={styles.mainContentArea}>
      {!selectedTagName ? (
        <TagCategoryHeader
          selectedTagCategory={selectedTagCategory}
          onTagCreated={onTreeRefresh}
          onClassificationUpdated={onTreeRefresh}
        />
      ) : (
        <TagDetailHeader selectedTagFqn={selectedTagFqn} onTagUpdated={onTreeRefresh} />
      )}
      <div className={styles.mainContent}>
        <div className={styles.contentArea}>
          {!selectedTagName ? (
            <TagCategoryTable selectedTagCategory={selectedTagCategory} />
          ) : (
            <TagAssetList tagFqn={selectedTagFqn} />
          )}
        </div>
        <div className={styles.sidebarArea}>
          {!selectedTagName ? (
            <TagCategorySidebar selectedTagCategory={selectedTagCategory} />
          ) : (
            <TagDetailSidebar selectedTagFqn={selectedTagFqn} />
          )}
        </div>
      </div>
    </article>
  );
};

const Fallback = () => {
  return <SuspenseFallback className={styles.fallback} />;
};

type TagContentsErrorProps = React.ComponentProps<typeof ErrorFallback> & {
  title: string;
  description: string;
};

const Error = ({ title, description, ...props }: TagContentsErrorProps) => {
  return <ErrorFallback title={title} description={description} className={styles.error} {...props} />;
};

export const TagContents = { Main, Fallback, Error };
